<template>
    <header class="container super-header-container-nts">
        <div class="is-justify-content-space-between header-container-nts">
            <div class="logo-header-new-tab-system">
                <a class="navbar-item logo-new-tab-system" href="#">
                    <Logo />
                </a>
            </div>
            <div class="user-menu-header">
                <div class="dropdown-label-user-menu" @click="isDropdownOpen = !isDropdownOpen">
                    <div :class="['username-class-nts', { 'username-grey-nts': isDropdownOpen }]">{{ user.username }}</div>
                    <div :class="['dropdown-menu-user-menu', { 'dropdown-hidden-user-menu': !isDropdownOpen }, { 'dropdown-shown-user-menu': isDropdownOpen }]">
                        <div v-if="user.client_type != BASIC" class="dropdown-item-user-menu" @click="goToLink('https://www.cforemoto.com/video-tutorials/')">
                            <i class="material-icons is-size-6 mr-2">ondemand_video</i>
                            Manual de uso
                        </div>
                        <div v-if="user.is_staff" class="dropdown-item-user-menu" @click="modalSelfUserDelete">
                            <i class="material-icons is-size-6 icon-clear mr-2">settings_power</i>
                            Borrar mis datos
                        </div>
                        <div v-if="user.is_superuser" class="dropdown-item-user-menu" @click="goToLink(`${hostBackend}/admin`)">
                            <i class="material-icons is-size-6 icon-clear mr-2">settings</i>
                            Ir al administrador
                        </div>
                        <div v-if="user.is_superuser" class="dropdown-item-user-menu" @click="modalUsersManager">
                            <i class="material-icons is-size-6 icon-clear mr-2">style</i>
                            Gestión de usuarios
                        </div>
                        <div class="dropdown-item-user-menu" @click="clearUserInfo">
                            <i class="material-icons is-size-6 icon-clear mr-2">logout</i>
                            Salir
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="user.user_info_loaded && has_multiple_tabs" class="tab-header-new-tab-system">
            <a class="menu-tab-new-tab-system" 
                v-if="user.has_conciliator"
                @click="setSection('conciliador')"
                :class="['panel_up_top', { 'is-disabled-tab-cfo': currentSection != 'conciliador' }, {'is-active-tab-cfo': currentSection == 'conciliador'}]">
                <span class="TLA">CON</span>CILIACION<span class="second-word-new-tab-system TLA">BAN</span>CARIA</a>
            <a class="menu-tab-new-tab-system second-word-new-tab-system"
                v-if="user.has_embedded_report"
                @click="setSection('reporte')"
                :class="['panel_up_top', { 'tab-header-is-totally-grey': !chartLoaded }, { 'is-disabled-tab-cfo': currentSection != 'reporte' }, {'is-active-tab-cfo': currentSection == 'reporte'}]">
                <span :class="['TLA', { 'tab-header-is-totally-grey': !chartLoaded }]">REP</span>ORTE <span :class="['TLA', 'second-word-new-tab-system', { 'tab-header-is-totally-grey': !chartLoaded }]"> FINA</span>NCIERO
            </a>
            <a class="menu-tab-new-tab-system second-word-new-tab-system"
                v-if="user.has_file_upload"
                @click="setSection('fileUpload')"
                :class="['panel_up_top', { 'is-disabled-tab-cfo': currentSection != 'fileUpload' }, {'is-active-tab-cfo': currentSection == 'fileUpload'}]">
                <span class="TLA">SUB</span>IR <span class="second-word-new-tab-system TLA"> ARC</span>HIVOS
            </a>
        </div>
    </header>
</template>

<script>
import SelfUserDelete from "@/components/modals/SelfUserDelete";
import UsersManager from "@/components/modals/UsersManager";
import Logo from "@/components/svg/Logo.vue";
import config from "@/config";
import router from "@/router";
import { getSession } from "@/utils/auth";
import { mapActions, mapState } from "vuex";
import { BASIC, CLASSIC } from "@/utils/clientTypes";


export default {
    name: "Header",
    components: { Logo },
    data() {
        return {
            clicksEnabled: false,
            hostBackend: "",
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            BASIC,
            CLASSIC,
            selectedSection: 'none',
            isDropdownOpen: false,
            has_multiple_tabs: false,
        };
    },
    props: {
        currentSection: String,
        chartLoaded: Boolean,
    },
    methods: {
        ...mapActions("userAuth", [
            "clearUserInfo",
            "setLoginInfo",
            "deleteSelf",
            "getUserInfo",
        ]),
        moreThanOneTrue(...args) {
            let trueCount = args.reduce((count, value) => count + (value === true ? 1 : 0), 0);
            return trueCount > 1;
        },
        goToLink(url) {
            window.location.href = url;
        },
        modalSelfUserDelete() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: SelfUserDelete,
            });
        },
        modalUsersManager() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: UsersManager,
            });
        },
        setSection(section) {
            if (this.clicksEnabled) {
                this.selectedSection = section;
                this.$emit('change-section', section);
            }
        },
    },
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    created() {
        let session = getSession();
        if (session) {
            this.setLoginInfo(session);
            this.getUserInfo(session.user.email);
        } else {
            this.clearUserInfo();
            router.push("/");
        }
        if (this.user.is_superuser) this.hostBackend = config.baseApi;
    },
    watch: {
        chartLoaded(newValue) {
            if (newValue) {
                this.clicksEnabled = true;
            }
        },
        user(newValue) {
            if (newValue.user_info_loaded) {
                this.has_multiple_tabs = this.moreThanOneTrue(this.user.has_conciliator,this.user.has_embedded_report, this.user.has_file_upload);
            }
        },
    }
};
</script>
<style>
.super-header-container-nts {
    width: 90%;
    display: flex;
    flex-direction: column;
}
.header-container-nts {
    height: 4.5em;
    float: left; 
    width: 50%; 
}
.logo-header-new-tab-system{
    align-items: center;
    display: flex;
    float: left; 
    width: 50%; 
    height: 76px;
}
.logo-new-tab-system {
    width: 220px;
}
.menu-tab-new-tab-system {
    font-size: 1.3em;
    padding: 8px 8px 0px 8px;
    width: 50%;
    position: relative;
}
.tab-header-new-tab-system {
    user-select: none;
    width: 100%;
    text-align: center;
    align-items: center;
    bottom: 0px;
    height: 25px;
    grid-column: span 2;
    border-bottom: solid 4px;
    border-image: linear-gradient(90deg, 
        #ffffff, 
        #dddddd 15%,
        #dddddd 85%, 
        #ffffff) 1;
}
.second-word-new-tab-system {
    margin-left: 0.3em;
}
.panel_up_top{
    color: #000000;
    margin-top: 20px;
    border-color: #dddddd;
    border-width: 3px;
    border-style: solid solid none solid;
    position: relative;
    bottom: 7px;
}
.is-active-tab-cfo {
  position: relative;
  bottom: 5px;
  z-index: 1;
  background-color: #ffffff;
}
.TLA {
    font-weight: bold; 
    color: #0000ff;
}
.is-disabled-tab-cfo {
  color: grey !important;
  cursor: default;
  background-color: #dddddd;
  bottom: 5px;
}
.is-disabled-tab-cfo .TLA {
    font-weight: normal; 
    color: #1111bb;
}

@media screen and (max-width: 460px) {
    .menu-tab-new-tab-system {
        font-size: 0.6em;
    }
    .panel_up_top {
        bottom: -4px;
    }
    .tab-header-new-tab-system {
        bottom: 2px;
        justify-content: left; /* Horizontally center the content */
    }
}
@media screen and (min-width: 461px) and (max-width: 900px) {
    .menu-tab-new-tab-system {
        font-size: 1em;
    }
    .panel_up_top {
        bottom: -2px;
    }
    .tab-header-new-tab-system {
        height: 25px;
        justify-content: center; /* Horizontally center the content */
    }
}
.user-menu-header {
    margin-top: 6px;
    display: flex; /* Use flexbox */
    flex-direction: column; /* Stack children vertically */
    align-items: flex-end; /* Align children to the right */
    text-align: right;
    position: absolute; /* For positioning the dropdown absolutely within this container */
    right: 1em;
    z-inder: 1000;
}
.dropdown-label-user-menu {
    padding: 10px 5px 10px 5px;
    cursor: pointer;
}
.dropdown-menu-user-menu:hover {
    display: block; /* Show the menu when hovering */
}

.dropdown-item-user-menu {
    text-align: left;
    margin-bottom: 5px;
    padding-left: 20px;
}
.dropdown-item-user-menu:hover {
    background-color: #f0f0f0;
    text-align: left;
}
.dropdown-item-user-menu:last-child {
    margin-bottom: 0; /* Remove margin for the last item */
}
.username-class-nts {
    background-color: #fefefe;
    padding: 5px 5px 0px 5px;
}
.username-class-nts:hover {
    background-color: #fafafa;
    padding: 5px 5px 0px 5px;
}
.username-grey-nts {
    background-color: #fafafa;
}
.dropdown-menu-user-menu {
    display: none; /* Initially hidden */
    position: relative; /* Positioned absolutely within user-menu-header */
    background-color: #fefefe; /* Solid background color */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Drop shadow */
    z-index: 2; /* Ensure it's above other content */
    left: 0px;
    top: 1em; /* Position just below the user-menu-header */
    width: 100%; /* Adjust width as needed */
    text-align: right;
    /* Additional styling as needed */
}
.dropdown-hidden-user-menu {
    display: none;
}
.dropdown-shown-user-menu {
    display: block;
}
.tab-header-is-totally-grey {
    color: #aaaaaa !important;
}
</style>